/** @jsx jsx */

import { useState, useEffect } from 'react';
import { css, jsx } from '@emotion/core';

import Modal from 'components/UI/Modal';
import { Box } from '@chameleoncreator/creator-ui';

import { ThemeProvider } from 'emotion-theming';
import { theme } from 'theme';
import getStore from 'services/getStore';
import getTopics from 'services/apiHelpers/getTopics';
import getInteractionsInTopic from 'services/apiHelpers/getInteractionsInTopic';
import EditorBtn from 'components/UI/EditorBtn';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';

import { clearLocationHistory } from 'services/clearLocationHistory';
import { useSelector } from 'react-redux';
import { State } from 'store/store';

const store = getStore();

const Bookmark = () => {
  const [bookmark, setBookmark] = useState<string | null>(null);

  const {
    textColor,
    buttonBackgroundColor,
    buttonTextColor,
    fontFamily,
  } = store.getState().theme;

  const { bookmarkLocation, bookmarkLoaded } = useSelector((state: State) => {
    return {
      bookmarkLocation: state.bookmarkLocation,
      bookmarkLoaded: state.bookmarkLoaded,
    };
  });

  useEffect(() => {
    // return;

    if (window.dev && window.dev()) {
      return;
    }

    if (!bookmarkLocation || bookmarkLocation === 'null') {
      return;
    }

    const root = document.querySelector('#root')!;

    const tick = setInterval(() => {
      const ariaHidden = root.getAttribute('aria-hidden');

      if (ariaHidden === 'false') {
        root.setAttribute('aria-hidden', 'true');
        document.body.style.overflowY = 'hidden';

        clearInterval(tick);
      }
    }, 1000 / 60);

    return () => {
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflowY = 'auto';

      clearInterval(tick);
    };
  }, [bookmarkLocation]);

  useEffect(() => {
    const location = bookmarkLocation;

    if (!location || location === 'null') {
      return;
    }

    // testing this as 1/1
    // but need to calculate what the actual first topic / interaction is

    const firstTopic: any = getTopics()[0];
    const firstInteraction: any = getInteractionsInTopic(firstTopic)[0];

    if (!firstTopic || !firstInteraction) {
      return;
    }

    const firstTopicSId = firstTopic.props.sId || firstTopic.id;
    const firstInteractionSId =
      firstInteraction.props.sId || firstInteraction.id;

    if (
      location &&
      location !== '' &&
      location !== `${firstTopicSId}/${firstInteractionSId}`
    ) {
      //

      setBookmark(location);
    }
  }, [bookmarkLoaded, bookmarkLocation]);

  return !!bookmark ? (
    <ThemeProvider theme={theme}>
      <Modal useFader={false} onClose={() => setBookmark(null)}>
        <Box
          // className="fader_-5s"
          css={css`
            padding: 50px;
          `}
        >
          <Box
            css={css`
              margin: 20px 0;
            `}
          >
            <h4
              css={css`
                text-align: center;
                color: ${textColor};
              `}
            >
              Would you like to return to where you left off?
            </h4>
          </Box>
          <Box
            css={css`
              display: flex;
              justify-content: center;
            `}
          >
            <div
              css={css`
                display: flex;
              `}
            >
              <EditorBtn
                ariaLabel="Yes"
                label="YES"
                data-custom-label={true}
                css={css`
                  margin: 0 20px;
                  background: ${buttonBackgroundColor};
                  color: ${buttonTextColor};
                `}
                onClick={() => {
                  window.location.hash = bookmark;

                  requestAnimationFrame(() => {
                    clearLocationHistory();
                    setBookmark(null);
                  });
                }}
              />

              <EditorBtn
                ariaLabel="No"
                label="NO"
                css={css`
                  margin: 0 20px;
                  background: ${buttonBackgroundColor};
                  color: ${buttonTextColor};
                `}
                onClick={() => {
                  setCurrentTopic(getTopics()[0].id);
                  setBookmark(null);
                }}
              />
            </div>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  ) : null;
};

export default Bookmark;
